import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.css'

class SlideCordionExtend {
  container: HTMLElement
  sliders!: Array<Swiper>

  constructor(container: HTMLElement) {
    this.container = container
    this.sliders = []

    if (this.container) {
      this.slider()
      this.inputsHandler()
    }
  }

  private slider() {
    const { container, sliders } = this

    const slidersContainer = container.querySelectorAll('.swiper-container')
    if (slidersContainer.length) {
      slidersContainer.forEach(slider =>
        sliders.push(
          new Swiper(slider as HTMLElement, {
            autoplay: {
              disableOnInteraction: true,
              delay: 3000,
            },
            speed: 1000,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            loop: true,
            pagination: {
              el: slider.closest('.slidecordion__slide')?.querySelector('.swiper-pagination') as HTMLElement,
              clickable: true,
            },
          }),
        ),
      )

      this.sliders.forEach(slider => slider.autoplay.stop())
      this.sliders[0].autoplay.start()
    }
  }

  private inputsHandler() {
    const { container, sliders } = this

    const inputs = container.querySelectorAll('.slidecordion__input')
    inputs.forEach(input =>
      input.addEventListener('change', () => {
        const index = input.getAttribute('data-index')

        if (index) {
          const currentSlider = sliders[parseInt(index)]

          sliders.forEach(slider => {
            slider.autoplay.stop()
            slider.slideTo(0)
          })

          setTimeout(() => {
            currentSlider.update()
            currentSlider.autoplay.start()
          }, 500)
        }
      }),
    )
  }
}

export default SlideCordionExtend
